import { useContext, useState } from "react";
import { Button, Col, Form, Input, Modal, Row } from "antd";
import { useDispatch } from "react-redux";
import { WarningFilled } from "@ant-design/icons";

import { createEmailConfiguration } from "../../actionCreator/emailSetupActionCreater";
import { useAlert } from "../../context/AlertProvider";
import { EmailContext } from "../../context/EmailContext";

const IMAP_SMTP_REGEX = /^(imap|smtp)\.[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const SMTPEmail = ({ isOpen, email, handleCancel }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { showAlert } = useAlert();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const { refetch } = useContext(EmailContext);

  const onClose = () => {
    handleCancel();
    form.resetFields();
    setError();
  };
  const onSubmit = async (values) => {
    setLoading(true);
    setError();
    const payload = {
      email: values?.email,
      smtpConfiguration: {
        ...values,
      },
    };
    const res = await dispatch(createEmailConfiguration(payload));

    if (res.status === 201) {
      onClose();
      refetch();
      setLoading(false);
      setError();
      showAlert("success", `Your Email is Connected!`);
    } else {
      setLoading(false);
      setError(res?.response?.data?.title);
      showAlert("error", res?.response?.data?.title);
    }
  };

  return (
    <Modal
      title={null}
      className="delete-popup"
      open={isOpen}
      centered
      footer={null}
      onOk={onClose}
      onCancel={onClose}
    >
      <>
        <div className="tw-bg-secondary-color tw-text-text-primary tw-text-lg tw-font-semibold tw-py-4 tw-px-6 tw-rounded-t-2xl">
          Connect Email Account
        </div>
        <div className="heading13px" style={{ padding: "10px 24px 10px" }}>
          <p className="heading18px fw-bold">Sign In</p>
          <p>Enter your credentials to continue</p>
          <div className="change-email-card mt20">
            <div className="d-flex align-items-start" style={{ gap: 15 }}>
              <WarningFilled className="heading24px" />
              <div>
                <p>
                  We suggest{" "}
                  <span className="tw-text-theme">
                    using an alternative email provider
                  </span>{" "}
                  instead of IMAP for a more dependable and seamless email
                  synchronization.
                </p>
                <p className="mt10 fw-bold cursor-pointer" onClick={onClose}>
                  Change Email Provider
                </p>
              </div>
            </div>
          </div>
        </div>
        <Form
          form={form}
          layout="inline"
          className="mt10 d-flex flex-column"
          style={{ gap: 20 }}
          initialValues={{ email }}
          onFinish={onSubmit}
        >
          <div
            className="heading13px d-flex flex-column"
            style={{ gap: 15, padding: "10px 24px 10px" }}
          >
            {error && <p className="text-error text-center pb-2">{error}</p>}
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please enter a username",
                },
              ]}
            >
              <div className="d-flex flex-column">
                <label className="heading12px pb-1">
                  Username<span className="text-error">*</span>
                </label>
                <Input className="common-input" />
              </div>
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter password",
                },
              ]}
            >
              <div className="d-flex flex-column">
                <label className="heading12px pb-1">
                  Password<span className="text-error">*</span>
                </label>
                <Input.Password className="common-input" />
              </div>
            </Form.Item>
            <Row style={{ width: "100%" }}>
              <Col span={16}>
                <Form.Item
                  name="imapHost"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Incoming server (IMAP)",
                    },
                    {
                      pattern: IMAP_SMTP_REGEX,
                      message: "Invalid IMAP server format!",
                    },
                  ]}
                >
                  <div className="d-flex flex-column">
                    <label className="heading12px pb-1">
                      Incoming server (IMAP)
                      <span className="text-error">*</span>
                    </label>
                    <Input className="common-input" />
                  </div>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="imapPort"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Incoming server (IMAP) Port",
                    },
                  ]}
                >
                  <div className="d-flex flex-column">
                    <label className="heading12px pb-1">
                      Port<span className="text-error">*</span>
                    </label>
                    <Input min={0} type="number" className="common-input" />
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col span={16}>
                <Form.Item
                  name="smtpHost"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Outgoing server (SMTP)",
                    },
                    {
                      pattern: IMAP_SMTP_REGEX,
                      message: "Invalid SMTP server format!",
                    },
                  ]}
                >
                  <div className="d-flex flex-column">
                    <label className="heading12px pb-1">
                      Outgoing server (SMTP)
                      <span className="text-error">*</span>
                    </label>
                    <Input className="common-input" />
                  </div>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="smtpPort"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Outgoing server (SMTP) Port",
                    },
                  ]}
                >
                  <div className="d-flex flex-column">
                    <label className="heading12px pb-1">
                      Port<span className="text-error">*</span>
                    </label>
                    <Input type="number" min={0} className="common-input" />
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div
            className="d-flex align-items-center justify-content-between"
            style={{
              borderTop: "0.20000000298023224px solid #e2e2e2",
              padding: "10px 24px 10px",
            }}
          >
            <p
              className="tw-text-theme heading13px fw-semibold cursor-pointer"
              onClick={onClose}
            >
              Not using IMAP?
            </p>
            <Form.Item>
              <Button
                loading={loading}
                type="primary"
                htmlType="submit"
                className="!tw-bg-theme tw-font-medium !tw-outline-0 !tw-border-theme !tw-text-white tw-font-medium tw-text-sm"
              >
                Sign in
              </Button>
            </Form.Item>
          </div>
        </Form>
      </>
    </Modal>
  );
};

export default SMTPEmail;
